var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_271_9850",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_271_9850",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAADQklEQVR4nO3bzYscRRjH8c8Oq8ZswKNG8ZCsiAcPEvSkByGCehfxJRrIwZOIyaoXD+bgJSC+IIggChKjiMcccsn+C76AIMQkJyOuh7ghYX0L0UPNMjWzu91TM7PzdCb9hYanp6uqn/pNPVXVM0/PmSwdPI87J9xuFf/gd/yE7/DfFO+9gRe7DkQdF/Aebt/ujm7FCzUOTuu4jNcwV+dwbYFCOngO90+43Spuxm48ijsGrn2FQ/hriv6E0cHj+Fb/aPjS5L/oRjOP9/WLsBTqURAf6J8TBsNj5pnXHw7vblaoJDYW8BgWcdO43hXwL1aMts4/gVNd+wLuLqyPJNLrWBW/vP0qrfPDDucOfsvq7yvtfEeaRaM7PnhcwRuGG8FfZ/WeGbw4X1N5Cc9m5+ewjD+GuPG4PIKHu/bP2CWt96RwPIaHcBBrFe38ktlFW/QF/cP+E9xS0sCYHM3ufVQajU/ie/2j4RvVI2GwnT46FRX347aufRYv4++SHkyYa9KE9iA+zD5/Str2jkSVAPdm9mmxnc+5ilf0i/CWEdf5KgF2ZfbKKI2PyeXM3r3J9SP4oWsvSJNiMVUCRHMms/fbOP9cxZvZ+dNG2PM3WYBlaRImbb4+slGEU9I6D3fhgdKb1C2DkazhbbzTPT8kPfKexvms3Kpe/N8n7RaHpskCkPbv+6TfGGAvXqooX/xTXJNDgLR2H5A2ZKs1ZRlhsm76CKD3JPexNBneY/Pf/H6Utu1FXA8CrLOGk5NutOkhsO3c8AJcTyGwFet/xsAJ6ZlhaGZBgAP4PDs/XlJ5FkJgb2YvllaeBQHGohUg2oFoWgGiHYimFSDagWhaAaIdiKYVINqBaFoBoh2IphUg2oFoWgGiHYimFSDagWhaAaIdiKYVINqBaFoBoh2IphUg2oEpcC6zzw5enIU/R+s4oZcivyGD5EYQ4Bq+2OpiVQjUZWo2hTwz7FJp5SoB6jI1m8AO6S2Wdc5sVXAUdkrvBaynmn+qWSLswGd6/l3EraWN1OXWLullapIyNAczNSNYlL75Pdlnh6XX5SbKnN4s2uTjuG18OXJOSk3Pw6Epx0W8Ok7nSyruVJ2pOU1WpPeIlvHnOA39D6CWXWZE19OBAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7460a9cc72378ef93f8b7d839ee0f59a.svg";
export { ForwardRef as ReactComponent };